import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { languages } from '@/helpers/languages';
import { changeLocale } from '@/actions/translations';
import { RadioButtonsSelectModal } from '@/components';

const SelectLanguageModal = props => {
  const { open, locale, webComponentConfing, filteredLanguage, setOpen, changeLocale, handleSetFilteredLanguage } = props;
  const intl = useIntl();
  const header = intl.formatMessage({ id: 'core.selectLanguage', defaultMessage: 'Select Language' });

  useEffect(() => {
    const userLang = navigator.language || navigator.userLanguage;
    const newLocale = locale || userLang.split('-')[0];
    const _filteredLanguage = webComponentConfing?.locale ? languages?.find(l => (l.id === webComponentConfing.locale || webComponentConfing.locale.includes(l.id))) : languages?.find(l => l.id === newLocale);

    if (_filteredLanguage) {
      handleSetFilteredLanguage(_filteredLanguage);
    }
  }, []);

  const handleLocalChange = language => {
    handleSetFilteredLanguage(languages.find(l => l.id === language));
    changeLocale(language);
    setOpen(false);
  };

  return open ? (
    <RadioButtonsSelectModal
      open
      header={header}
      list={languages?.map(l => ({ value: l.id, label: l.name }))}
      preselect={filteredLanguage?.id}
      setOpen={setOpen}
      onChange={language => handleLocalChange(language)}
    />
  ) : null;
};

const mapStateToProps = ({ core, cmmeReducer }) => {
  return {
    locale: core.locale,
    webComponentConfing: cmmeReducer.config,
  };
};

export default connect(mapStateToProps, { changeLocale })(SelectLanguageModal);
